import React, { useContext } from "react";

import { ChevronLeftIcon } from "@radix-ui/react-icons";
import { Link } from "react-router-dom";
import SharedDataContext from "../../../SharedDataContext";
import ProfileSetting from "../../ext/settings/ProfileSetting";
import Header from "../../ext/Header";
import { returnRecentPagePath, sendEventToloadBulkProfilePage } from "../../../utils/GenericFn";

export default function Profile() {
  const { userData, params } = useContext(SharedDataContext);
  return (
    <>
      <Header homeLink={returnRecentPagePath(params)} />
      <div className="space-y-3 p-3">
        <div>
          <Link to={returnRecentPagePath(params)} className="inline-flex items-center">
            <span
              className="inline-flex items-center"
              onClick={() => {
                if (params?.bulkProfilePage) {
                  sendEventToloadBulkProfilePage();
                }
              }}
            >
              <ChevronLeftIcon /> <span>Back</span>
            </span>
          </Link>
        </div>
        <div className="flex py-3 px-5 items-center border-b border-border  bg-background rounded-[14px]">
          <img src={userData?.profile_photo_url} alt="User" className="mr-2 rounded-full shadow w-10 h-10 no-invert" />
          <div className="flex-1 items-center">
            <span className="text-[16px] text-gray-900 block">{userData?.name}</span>
          </div>
        </div>
        <ProfileSetting />
      </div>
    </>
  );
}
